import ReactModal from "react-modal";
import { useFormik } from "formik";
import * as Yup from "yup";

import styles from "./CreateDepartmentModal.module.css";
import Icon from "../Icon/Icon";

type StatusModalPropsType = {
  isOpen: boolean;
  onRequestClose: () => void;
  handleCreateDepartment: (name: string) => void;
  existingDepartmentsNames: string[] | null;
};

const CreateDepartmentModal = ({
  isOpen,
  onRequestClose,
  handleCreateDepartment,
  existingDepartmentsNames,
}: StatusModalPropsType) => {
  const validationSchema = Yup.object({
    departmentName: Yup.string()
      .trim()
      .required("¡El nombre no puede estar vacío!")
      .test(
        "is-unique",
        "¡Este nombre de departamento ya existe!",
        function (value) {
          if (!value || !existingDepartmentsNames) return true;
          const lowerCased = value.trim().toLowerCase();
          return !existingDepartmentsNames.some(
            (name) => name.trim().toLowerCase() === lowerCased
          );
        }
      ),
  });

  const formik = useFormik({
    initialValues: {
      departmentName: "",
    },
    validationSchema,
    onSubmit: (values) => {
      handleCreateDepartment(values.departmentName.trim());
      onRequestClose();
      formik.resetForm();
    },
  });

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => {
        onRequestClose();
        formik.resetForm();
      }}
      className={styles.modal}
      overlayClassName={styles.overlay}
      ariaHideApp={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <h4 className={styles.modalTitle}>Crear departamento</h4>
        <p className={styles.modalText}>
          Escribe el nombre del departamento, donde se almacenaran los
          documentos correspondientes
        </p>

        {formik.touched.departmentName && formik.errors.departmentName && (
          <div className={styles.textWarning}>
            {formik.errors.departmentName}
          </div>
        )}

        <input
          type="text"
          name="departmentName"
          className={styles.input}
          placeholder="Nombre del departamento"
          value={formik.values.departmentName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          autoComplete="off"
        />

        <div className={styles.buttonsContainer}>
          <button
            type="button"
            className={`${styles.button} ${styles.cancelButton}`}
            onClick={onRequestClose}
          >
            Cancelar
          </button>
          <button
            type="submit"
            className={`${styles.button} ${styles.submitButton}`}
          >
            Crear
          </button>
        </div>
      </form>
      <button className={styles.closeIcon} onClick={onRequestClose}>
        <Icon name="x-mark" size={16} />
      </button>
    </ReactModal>
  );
};

export default CreateDepartmentModal;
